import React from 'react';
import { FormModal, FormField } from '../../../components/ui/Modal';
import { useAddTagModal } from './AddTagModal.hooks';

interface AddTagModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (data: { nombre: string; descripcion: string; color: string }) => Promise<void>;
}

const AddTagModal: React.FC<AddTagModalProps> = ({ isOpen, onClose, onSave }) => {
  const { formData, loading, error, handleFormChange, handleSave, handleClose } = useAddTagModal();

  const fields: FormField[] = [
    {
      name: 'nombre',
      label: 'Nombre',
      type: 'text',
      placeholder: 'Ej. Nuevo, En oferta',
      required: true,
    },
    {
      name: 'color',
      label: 'Color',
      type: 'color',
      defaultValue: '#9CA3AF',
    },
    {
      name: 'descripcion',
      label: 'Descripción',
      type: 'textarea',
      placeholder: 'Descripción de la etiqueta...',
      rows: 3,
    },
  ];

  const handleSaveClick = async () => {
    await handleSave(onSave);
  };

  // Convert formData to Record<string, string> for FormModal
  const formDataRecord: Record<string, string> = {
    nombre: formData.nombre || '',
    descripcion: formData.descripcion || '',
    color: formData.color || '#9CA3AF',
  };

  return (
    <FormModal
      open={isOpen}
      onClose={() => handleClose(onClose)}
      title="Agregar Etiqueta"
      fields={fields}
      formData={formDataRecord}
      onFieldChange={handleFormChange}
      onSave={handleSaveClick}
      loading={loading}
      error={error}
      saveButtonText="Guardar"
      cancelButtonText="Cancelar"
      maxWidth="sm"
      variant="simple"
    />
  );
};

export default AddTagModal;
